import Core from '../../Core/Core';
import { Actions } from '../../State/Actions/Actions';
import { BoosterId } from '../../State/reducers/boosters';
import { IStateScore } from '../../State/reducers/score';
import { IGameState } from '../../State/Store/store';
import { BoosterParachute } from '../../UI/Game/Helpers/BoosterParachute';
import HudView from '../../View/HudView';
import { HudActions, HudEmitter } from './HudEmitter';
import { Manager } from '../Manager';
import HelperTracking, { HelperTrackStages } from '../Tracking/HelperTracking';

export class Animations extends Manager {
    private readonly view: HudView;

    constructor(view: HudView) {
        super();

        this.view = view;
        this.addSelector(
            (state: IStateScore, pre: IStateScore) => {
                this.handleComboChange(state, pre);
            },
            (state: IGameState) => state.StateScore
        );
        HudEmitter.instance.on(
            HudActions.SHOW_BOOSTER_PARACHUTE,
            this.showBoosterParachute.bind(this)
        );
        HudEmitter.instance.on(
            HudActions.SHOW_ACTIVATION_PARACHUTE,
            this.showActivationParachute.bind(this)
        );
    }

    public update() {}

    public cleanUp() {
        super.cleanUp();
    }

    private handleComboChange(state: IStateScore, previous: IStateScore) {
        if (!this.view || !this.view.topUi) {
            return;
        }
        // remove flavor text from top ui...
        if (state.multiplier !== previous.multiplier) {
            this.view.topUi.showCombo(state.multiplier, previous.multiplier);
        }
        if (state.multiplier !== previous.multiplier && state.multiplier === 1) {
            this.view.topUi.showFlavorText(previous.multiplier);
        }
    }

    private async showBoosterParachute(boosterId: BoosterId) {
        HudEmitter.instance.emit(HudActions.HIDE_BOOSTER_PARACHUTE);
        const hide = (success: boolean) => {
            if (boosterParachute) {
                boosterParachute.tweenOut(success);
                boosterParachute = null;
                clearTimeout(timeout);
            }
        };

        HelperTracking.track(boosterId, HelperTrackStages.SHOW);
        const friend = await Core.sdk.messages.getRandomFriend();
        let boosterParachute = this.view.showHelperParachute(friend, boosterId);
        if (!boosterParachute) {
            return;
        }
        boosterParachute.on(BoosterParachute.events.Trigger, async () => {
            const state = Core.store.getState();
            const { activeBoosters } = state.StateBoosters;

            if (activeBoosters.includes(boosterId) || !state.StateBoard.ready) {
                return;
            }
            boosterParachute.off(BoosterParachute.events.Trigger);
            const item = { id: boosterId, val: 1 };
            HudEmitter.instance.emit(HudActions.ASK_FRIEND, friend, item, (success: boolean) => {
                Core.store.dispatch(Actions.askFriendComplete());
                hide(success);
            });
        });
        HudEmitter.instance.once(HudActions.HIDE_BOOSTER_PARACHUTE, () => hide(false));
        await boosterParachute.tweenIn();
        const timeout = setTimeout(hide, 30 * 1000);
    }

    private async showActivationParachute(boosterId: BoosterId) {
        const { helperFriend } = Core.store.getState().StateSocial;
        let parachute = this.view.showHelperParachute(helperFriend, boosterId);
        if (!parachute) {
            return;
        }
        const hide = () => {
            if (parachute) {
                parachute.destroy();
                parachute = null;
            }
        };
        HudEmitter.instance.once(HudActions.HIDE_BOOSTER_PARACHUTE, hide);
        await parachute.tweenIn();
        if (parachute) {
            Core.store.dispatch(Actions.silentStoreBooster([boosterId]));
            Core.store.dispatch(Actions.addBoosters([boosterId]));
        }
        Core.store.dispatch(Actions.askFriendComplete());
        if (parachute) {
            await parachute.tweenOut(true);
        }
    }
}
